import { render, staticRenderFns } from "./WaveletMarketplace.vue?vue&type=template&id=6b31b250&scoped=true&"
import script from "./WaveletMarketplace.vue?vue&type=script&lang=js&"
export * from "./WaveletMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./WaveletMarketplace.vue?vue&type=style&index=0&id=6b31b250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31b250",
  null
  
)

export default component.exports